(() => {
  const INTRO_DELAY = 1800;

  const initHero = (hero) => {
    if (!hero || hero.dataset.mtIntroReady === 'true') return;
    hero.dataset.mtIntroReady = 'true';
    hero.classList.remove('mt-hero--product-ready');

    const slides = hero.querySelectorAll('[data-hero-slide]');
    if (!slides.length) {
      hero.classList.add('mt-hero--product-ready');
      return;
    }

    hero.dispatchEvent(new MouseEvent('mouseenter'));

    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const delay = reducedMotion ? 1200 : INTRO_DELAY;

    window.setTimeout(() => {
      hero.classList.add('mt-hero--product-ready');
      if (!hero.matches(':hover')) {
        hero.dispatchEvent(new MouseEvent('mouseleave'));
      }
    }, delay);
  };

  const initAll = (root = document) => {
    root.querySelectorAll('.mt-hero').forEach(initHero);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll());
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const root = event.target || document;
    if (root.matches?.('.mt-hero')) initHero(root);
    initAll(root);
  });
})();
